import { useLang } from '@/i18n';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import EfSwiperCardBundle from '@elem/ui/ef-swiper-card-bundle';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';

export default function BundlesCommon() {
    const { t } = useLang('theProduct.Bundles');
    const variantIdA = '44505650528417';
    const itemsA1 = [
        {
            img: 'https://cdn.shopify.com/s/files/1/0412/3459/6001/files/sl_DP3.png?v=1719220012',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1722498164229/DPU%2BRV.jpg',
        },
        {
            img: 'https://cdn.shopify.com/s/files/1/0412/3459/6001/files/sl_DP3.png?v=1719220012',
        },
        {
            img: 'https://websiteoss.ecoflow.com/upload/image/1722498164229/DPU%2BRV.jpg',
        },
    ];
    const infoA1 = {
        productId: '8097380106401',
        variantId: variantIdA,
        tag: '',
        title: 'DELTA 3 Plus',
        subtitle: '',
        desc: t('item1_desc'),
        discountPrice: 679250,
        originalPrice: 779250,
        pointRate: 5,
        point: 17967,
        inventory: 100,
        linkMore: 'https://jp.ecoflow.com/products/river-3-portable-powerstation',
        showBtnMore: true,
        showBtnCart: false,
    };
    const { locale = 'us' } = useRouter();
    const [itemA, setItemA] = useState({
        items: itemsA1,
        info: infoA1,
    });

    useEffect(() => {
        const variantIds = [variantIdA];
        const initAll = async () => {
            const res = await getSolarRecommand2({ variantIds }, locale);
            if (res.code === '0') {
                const data = res.data || [];
                //第1个产品
                const itemA2 = data.find((item: any) => {
                    return item.variantId === variantIdA;
                });
                if (itemA2) {
                    infoA1.title = itemA2.productTitle;
                    infoA1.discountPrice = itemA2.price;
                    infoA1.originalPrice = itemA2.compareAtPrice;
                }

                setItemA({
                    items: itemsA1,
                    info: infoA1,
                });
            }
        };
        initAll();
    }, []);

    return (
        <div className={styles.BundlesCommon}>
            <EfSwiperCardBundle info={itemA.info} items={itemA.items} callbackCart={() => {}} />
        </div>
    );
}
